// 상단 우측 패널(남은 팀 수 / 인원)의 읽기를 받아 "바뀐 것만" 로그 항목으로 돌려주는 추적기 (순수 함수).
// - 같은 값이 연속 두 번 읽혀야 기록한다(게임 화면이 24↔23처럼 잠깐 흔들리거나 오인식한 한 프레임은 기록하지 않음).
// - 남은 팀 수는 줄어들기만 한다(늘어나는 읽기는 오인식으로 무시).
// - 인원은 부활(크레딧 부활 등)로 늘 수도 있다. 한 번에 크게(7 초과) 변하는 읽기는 더 오래 같은 값이 읽혀야 기록한다.
// - 인원이 ?로 가려지면(후반) 한 번만 기록하고, 읽을 수 없는 프레임(흐림 등)은 무시한다.
// - 인원이 남은 팀 수보다 적은 읽기는 말이 안 되므로 무시한다.

const CONFIRM_COUNT = 2;
const BIG_JUMP = 7;
const BIG_JUMP_CONFIRM_COUNT = 4;
const HIDDEN = 'hidden';

export function createStatusTracker() {
  let confirmedTeams = null;
  let confirmedPlayers; // undefined(아직 모름) | number | HIDDEN
  let teamsCandidate = null; // { value, count }
  let playersCandidate = null;

  // 후보를 한 번 더 본다. 확정에 필요한 횟수가 차면 확정 값을 돌려주고, 아니면 undefined.
  const observe = (candidate, value, needed) => {
    const next = candidate && candidate.value === value ? { value, count: candidate.count + 1 } : { value, count: 1 };
    return { next, confirmed: next.count >= needed };
  };

  return {
    update(reading) {
      if (!reading) {
        return [];
      }
      const entries = [];

      // 남은 팀 수
      if (typeof reading.teams === 'number' && (confirmedTeams === null || reading.teams <= confirmedTeams)) {
        if (reading.teams === confirmedTeams) {
          teamsCandidate = null;
        } else {
          const { next, confirmed } = observe(teamsCandidate, reading.teams, CONFIRM_COUNT);
          teamsCandidate = confirmed ? null : next;
          if (confirmed) {
            entries.push({ kind: 'teams', from: confirmedTeams, to: reading.teams });
            confirmedTeams = reading.teams;
          }
        }
      }

      // 인원 (숫자 또는 ?로 가려짐). 읽을 수 없으면(null이고 가려짐도 아님) 무시한다.
      const playersValue = reading.playersHidden ? HIDDEN : reading.players;
      const teamsNow = confirmedTeams === null ? reading.teams : confirmedTeams;
      const plausible = playersValue === HIDDEN || (typeof playersValue === 'number' && (typeof teamsNow !== 'number' || playersValue >= teamsNow));
      if (plausible && playersValue !== confirmedPlayers) {
        const bigJump = typeof confirmedPlayers === 'number' && typeof playersValue === 'number'
          && Math.abs(playersValue - confirmedPlayers) > BIG_JUMP;
        const { next, confirmed } = observe(playersCandidate, playersValue, bigJump ? BIG_JUMP_CONFIRM_COUNT : CONFIRM_COUNT);
        playersCandidate = confirmed ? null : next;
        if (confirmed) {
          if (playersValue === HIDDEN) {
            entries.push({ kind: 'playersHidden', from: typeof confirmedPlayers === 'number' ? confirmedPlayers : null, to: null });
          } else {
            entries.push({ kind: 'players', from: typeof confirmedPlayers === 'number' ? confirmedPlayers : null, to: playersValue });
          }
          confirmedPlayers = playersValue;
        }
      } else if (playersValue === confirmedPlayers) {
        playersCandidate = null;
      }
      return entries;
    },
    reset() {
      confirmedTeams = null;
      confirmedPlayers = undefined;
      teamsCandidate = null;
      playersCandidate = null;
    },
  };
}

// 로그 한 줄의 글
export function formatStatusEntry(entry) {
  switch (entry.kind) {
    case 'teams':
      return entry.from === null ? `남은 팀 ${entry.to}팀` : `남은 팀 ${entry.from} → ${entry.to}`;
    case 'players': {
      if (entry.from === null) {
        return `인원 ${entry.to}명`;
      }
      const diff = entry.to - entry.from;
      return `인원 ${entry.from} → ${entry.to} (${diff > 0 ? '+' : ''}${diff})`;
    }
    case 'playersHidden':
      return '인원 표시가 가려짐(?)';
    default:
      return '';
  }
}
